const COMPARE_PLANS = 'PlanEnroll.api.comparePlans';
const COUNTIES_KEY = 'PlanEnroll.api.counties';
const COUNTY_FIPS_KEY = 'PlanEnroll.api.countyFips';
const DOCTOR_ADDRESS_PAGE_KEY = 'PlanEnroll.api.doctorAddressPage';
const DOCTOR_DETAILS_KEY = 'PlanEnroll.api.doctorDetails';
const DOCTOR_NAMES_KEY = 'PlanEnroll.api.doctorNames';
const DOCTOR_SEARCH_TERM_KEY = 'PlanEnroll.api.doctorSearchTerm';
const DRUG_NAMES_KEY = 'PlanEnroll.api.drugNames';
const ENROLL_MODAL_INPUT_DATA = 'PlanEnroll.api.enrollModalInputData';
const LEAD_ID_KEY = 'PlanEnroll.api.leadId';
const PHARMACY_ADDRESS_PAGE_KEY = 'PlanEnroll.api.doctorAddressPage';
const PHARMACY_DETAILS_KEY = 'PlanEnroll.api.doctorDetails';
const PHARMACY_LIST_PAGE = 'PlanEnroll.api.pharmacyListPage';
const PHARMACY_NAMES_KEY = 'PlanEnroll.api.pharmacyNames';
const PHARMACY_SEARCH_TERM_KEY = 'PlanEnroll.api.doctorSearchTerm';
const PLAN_TYPE_KEY = 'PlanEnroll.api.planType';
const PRESCRIPTION_SEARCH_TERM_KEY = 'PlanEnroll.api.prescriptionSearchTerm';
const RADIUS_MILES_KEY = 'PlanEnroll.api.radiusMiles';
const ZIP_CODE_KEY = 'PlanEnroll.api.zipCode';
const PLAN_DATE_KEY = 'PlanEnroll.api.planDateKey';
const PLAN_DETAIL_DATE_KEY = 'PlanEnroll.api.planDetailDateKey';
const PLAN_YEAR_KEY = 'PlanEnroll.api.planYearKey';
const STATE_KEY = 'PlanEnroll.api.state';
const CONTACT_CALLBACK_KEY = 'PlanEnroll.api.contactCallback';
const REQUEST_CALLBACK_KEY = 'PlanEnroll.api.requestCallback';
const MEDICAID_KEY = 'PlanEnroll.api.medicaid';

export {
    COMPARE_PLANS,
    COUNTIES_KEY,
    COUNTY_FIPS_KEY,
    DOCTOR_ADDRESS_PAGE_KEY,
    DOCTOR_DETAILS_KEY,
    DOCTOR_NAMES_KEY,
    DOCTOR_SEARCH_TERM_KEY,
    DRUG_NAMES_KEY,
    ENROLL_MODAL_INPUT_DATA,
    LEAD_ID_KEY,
    PHARMACY_ADDRESS_PAGE_KEY,
    PHARMACY_DETAILS_KEY,
    PHARMACY_LIST_PAGE,
    PHARMACY_NAMES_KEY,
    PHARMACY_SEARCH_TERM_KEY,
    PLAN_DATE_KEY,
    PLAN_DETAIL_DATE_KEY,
    PLAN_TYPE_KEY,
    PLAN_YEAR_KEY,
    PRESCRIPTION_SEARCH_TERM_KEY,
    RADIUS_MILES_KEY,
    REQUEST_CALLBACK_KEY,
    ZIP_CODE_KEY,
    STATE_KEY,
    CONTACT_CALLBACK_KEY,
    MEDICAID_KEY
};
